// const lang = i18n.app.components.contract.contract;

export default [
  {
    key: "status.name",
    getName: () => i18n.app.common.status
  },
  {
    key: "contract_number",
    getName: () => i18n.app.components.contract.contract_number
  },
  {
    key: "order_number",
    getName: () => i18n.app.components.contract.order_number
  },
  {
    key: "depot.name",
    getName: () => i18n.app.components.contract.depot
  },
  {
    key: "issuer_name",
    getName: () => i18n.app.components.contract.issuer_name
  },
  {
    key: "intaker_name",
    getName: () => i18n.app.components.contract.intaker_name
  },
  {
    key: "client.company.name",
    getName: () => i18n.app.components.contract.client
  },
  {
    key: "leaseCompany.company.name",
    getName: () => i18n.app.components.contract.lease_company
  },
  {
    key: "dealers_names",
    getName: () => i18n.app.components.contract.dealer
  },
  {
    key: "credit_type",
    getName: () => i18n.app.components.contract.credit_type
  },
  {
    key: "vehicle.segment.name",
    getName: () => i18n.app.components.contract.segment
  },
  {
    key: "vehicle.license_plate_formatted",
    getName: () => i18n.app.components.contract.license_plate
  },
  {
    key: "vehicle.display_name",
    getName: () => i18n.app.components.contract.replacement_vehicle
  },
  {
    key: "conkedOutVehicle.display_name",
    getName: () => i18n.app.components.contract.conked_out_vehicle
  },
  {
    key: "conkedOutVehicle.license_plate_formatted",
    getName: () => i18n.app.components.contract.conked_out_license_plate
  },
  {
    key: "start_datetime",
    getName: () => i18n.app.components.contract.start_datetime
  },
  {
    key: "duration_in_days",
    getName: () => i18n.app.components.contract.duration_in_days
  },
  {
    key: "end_datetime",
    getName: () => i18n.app.components.contract.end_datetime
  },
  {
    key: "signed_off_at",
    getName: () => i18n.app.components.contract.signed_off_at
  }
];
